import "../../styles/UserDashboard/choosePaymentMethodModal.scss";

export default function P2PAccountDetailsModal({open, setOpen}) {
  return (
    open &&
    <div className="choose-payment-method-modal">
    <div className="choose-payment-method-modal__inner">
    <div className="choose-payment-method-modal__inner__title">
    Order summary
      </div>
      <div className="choose-payment-method-modal__inner__grid"
    
      >
        <div>Buying:</div>
        <div>50 kWh</div>
        <div>At:</div>
        <div>₦40 / 1 kWh</div>
        <div>Total:</div>
        <div>₦2,000</div>
        <div>300 kWh</div>
        <div>300 kWh</div>
      </div>
      <div className="choose-payment-method-modal__inner__grid"
    
      >
        <div>Account Number:</div>
        <div>3065421544</div>
        <div>Account Name:</div>
        <div>Adekoye Timilehin Grace</div>
        <div>Bank Name:</div>
        <div>First Bank</div>
      </div>
      <button
      onClick={() => setOpen(false)}
      >I have made payment</button>
    </div>
    </div>
  );
}
